import script from "./GreetingTile.vue?vue&type=script&setup=true&lang=js"
export * from "./GreetingTile.vue?vue&type=script&setup=true&lang=js"

import "./GreetingTile.vue?vue&type=style&index=0&id=532b56fb&lang=scss"

const __exports__ = script;

export default __exports__